import React, { useMemo } from 'react';

import Graph from '../Graph';

import { GraphDetail } from './GraphSection.styles';

const toNumber = val => {
  const num = Number(val);
  return Number.isNaN(num) ? 0 : num;
};

const GraphSection = ({
  isEdit,
  searchQuery,
  setSearchQuery,
  campaign_graph_data,
  graph_data,
  linkedin_data,
  embedded,
}) => {
  const graphData = useMemo(() => {
    if (isEdit) {
      if (!campaign_graph_data?.data?.results) return null;

      const results = campaign_graph_data.data.results;

      return {
        xAxis: results.map(item => item.label || ''),
        totalSending: results.map(item => toNumber(item.emailssent)),
        connectionsAccepted: results.map(() => 0),
        totalReplies: results.map(item => toNumber(item.replies)),
      };
    }

    const emailResults = graph_data?.data?.results || [];
    const linkedinResults = linkedin_data?.data?.results || [];

    if (emailResults.length === 0 && linkedinResults.length === 0) return null;

    const baseResults =
      emailResults.length >= linkedinResults.length ? emailResults : linkedinResults;

    return {
      xAxis: baseResults.map(item => item.label || ''),
      totalSending: baseResults.map(
        (_, index) =>
          toNumber(emailResults[index]?.emailssent) + toNumber(linkedinResults[index]?.connectionssent),
      ),
      connectionsAccepted: baseResults.map((_, index) =>
        toNumber(linkedinResults[index]?.connectionsaccepted),
      ),
      totalReplies: baseResults.map(
        (_, index) => toNumber(emailResults[index]?.replies) + toNumber(linkedinResults[index]?.messagesreplied),
      ),
    };
  }, [isEdit, graph_data, campaign_graph_data, linkedin_data]);

  return (
    <>
      <GraphDetail $embedded={embedded}>
        <div className="graph-holder">
          <Graph
            dashboardGraph
            embedded={embedded}
            graphData={graphData}
            tooltipBg="#f0f0f0"
            title="Leads Enrich"
            amount={5000}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
          />
        </div>
      </GraphDetail>
    </>
  );
};

export default GraphSection;
